import { OnInit, OnDestroy } from '@angular/core';
import { EditComponent } from '../../../components';
import { ViewMode } from '../../../enums';
import { PermissionService } from '../../../permission';

export abstract class EditPageComponent<T> extends EditComponent<T> implements OnInit, OnDestroy {
  public mode = ViewMode.Edit;

  constructor(protected permissionService?: PermissionService, protected editPermission?: string) {
    super();
  }

  private valid = false;

  public onChange(model: T) {
    this.model = model;
  }

  public onValidityChange(valid: boolean) {
    this.valid = valid;
  }

  public get disabled(): boolean {
    return this.loading || this.noChange || !this.valid;
  }

  /**
   * This method extends the EditComponent's setModel method with the filling of the editForm part.
   */
  public beforeModelLoaded() {
    if (super.beforeModelLoaded) {
      super.beforeModelLoaded();
    }

    if (this.editPermission) {
      this.mode = this.permissionService.canActivate(this.editPermission) ? ViewMode.Edit : ViewMode.View;
    }
  }
}
